import React, { useState, useEffect, useCallback } from "react";
import { Message } from "semantic-ui-react";
import "../styles/Snackbar.scss";

const Snackbar = ({ message, onClose, autoDismiss = 30000 }) => {
  const [isVisible, setIsVisible] = useState(true);
  const timerRef = React.useRef();
  const handleDismiss = useCallback(() => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
    clearTimeout(timerRef.current);
  }, [onClose]);

  useEffect(() => {
    if (isVisible) {
      timerRef.current = setTimeout(handleDismiss, autoDismiss);
    }
    return () => clearTimeout(timerRef.current);
  }, [isVisible, autoDismiss, handleDismiss]);

  useEffect(() => {
    setIsVisible(true);
  }, [message]);
  if (!isVisible) return null;

  return (
    <div className="snackbar-container">
      <Message onDismiss={handleDismiss} content={message} error floating />
    </div>
  );
};

export default Snackbar;
